<mat-form-field appearance="none" [ngClass]="'year-month-picker'">
  <input matInput [matDatepicker]="dp" [formControl]="date" [readonly]="true" [min]="minDate" [max]="maxDate" (click)="dp.open()">
  <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
  <mat-datepicker #dp
                  startView="multi-year"
                  (yearSelected)="chosenYearHandler($event)"
                  (monthSelected)="chosenMonthHandler($event, dp)"
                  disabled="false">
  </mat-datepicker>
</mat-form-field>
